<!--
 * @Author: Alfred huqitaoit@gmail.com
 * @Date: 2023-12-25 11:08:38
 * @LastEditors: Alfred
 * @LastEditTime: 2023-12-25 11:08:59
 * @Description: 
 * @FilePath: \src\views\operation\Operation.vue
-->
<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Operation',
  data() {
    return {}
  }
}
</script>
<style lang="" scoped></style>
